import useKioskSettingsQuery from "@/shared/queries/kioskSettings/useKioskSettingsQuery";
import useOpeningTimesStatusQuery, {
  OPENING_TIMES_OPEN_STATUS,
} from "@/shared/queries/openingTimes/useOpeningTimesStatusQuery";

const useIsKioskClosed = () => {
  const kioskSettingsQuery = useKioskSettingsQuery();
  const openingTimesStatusQuery = useOpeningTimesStatusQuery();

  const configuredMethods = kioskSettingsQuery.data?.delivery_methods || [];
  const statuses = openingTimesStatusQuery.data;

  if (!statuses || !configuredMethods.length) {
    return false;
  }
  return configuredMethods.every(
    (methodId) => statuses[methodId]?.status !== OPENING_TIMES_OPEN_STATUS
  );
};

export default useIsKioskClosed;
